import React from "react";
import { default as MuiTabList } from "@mui/lab/TabList";

function TabList(props) {
  return <MuiTabList {...props} />;
}

export default TabList;
